import { useState } from 'react';
import info from './img/info.png';
import croix from './img/croix.png';

export default function InfoBulle({ message }) {
  const [display, setDisplay] = useState(false);

  return (
    <span className="info-bulle-wrapper">
      <button
        type="button"
        className="info"
        style={{ backgroundImage: `url(${info})` }}
        onClick={() => setDisplay((prev) => !prev)}
        aria-expanded={display}
        aria-label="Plus d'informations"
      >
        + d&apos;infos
      </button>
      {display && (
        <div className="info-bulle" role="dialog" aria-label="Informations">
          <div className="info-bulle__header">
            <div className="info-bulle__title">
              <img src={info} alt="" className="info-img" />
              <span>Infos</span>
            </div>
            <button
              type="button"
              className="info-bulle__close"
              onClick={() => setDisplay(false)}
              aria-label="Fermer"
            >
              <img src={croix} alt="" />
            </button>
          </div>
          <div className="info-bulle__body">{message}</div>
        </div>
      )}
    </span>
  );
}
